import { supabase } from '@/lib/supabase/supabaseClient';

export const archiveQuestion = async (question_id: string) => {
    return await supabase
        .from('question')
        .update({ archived: true })
        .eq('id', question_id)
        .select()
        .throwOnError()
        .then(res => res.data);
}
